import React from 'react';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import Paper from 'components/Paper';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SGSubtitle from '../../../components/Typography/SGSubtitle';
import SGBody from '../../../components/Typography/SGBody';

const StyledModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: scroll;
`;

const StyledPaper = styled(Paper)`
  box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.25);
  max-height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
  width: 500px;
`;

const StyledModalHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.grey};
  margin: -14px -24px 8px -24px;
  padding: 14px 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const StyledIconButton = styled(IconButton)`
  color: ${props => props.theme.text};
  padding: 0;
`;

const StyledCloseIcon = styled(CloseIcon)`
  color: ${props => props.theme.text};
`;

const StyledModalBody = styled(Grid)`
  padding: 16px 0;

  p.s1,
  p.b4 {
    color: ${props => props.theme.white};
  }
`;
const StyledButton = styled(Button)`
  width: 100%;
  background-color: ${props => props.theme.activeStateBlue};
  font-family: 'Text Regular';
  border-radius: 10px;
  padding: 8px 12px;
  line-height: 18px;
  color: ${props => props.theme.defaultNavy};
  font-size: 0.75rem;
  &:hover {
    background-color: ${props => props.theme.activeStateBlue}77;
  }
`;

const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  color: ${props => props.theme.disabledStateBlue};
`;

function MultipleSelectionWarningModal({
  isModalOpen,
  handleConfirm,
  handleClose,
}: {
  isModalOpen: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
}) {
  return (
    <StyledModal
      aria-labelledby="multiple-selection-warning-modal"
      aria-describedby="multiple-selection-warning-modal"
      open={isModalOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isModalOpen}>
        <StyledPaper>
          <StyledModalHeader>
            <Grid container alignItems="center" spacing={2}>
              <StyledInfoOutlinedIcon />
              <Grid item>
                <span>Warning</span>
              </Grid>
            </Grid>
            <StyledIconButton aria-label="close modal" onClick={handleClose}>
              <StyledCloseIcon />
            </StyledIconButton>
          </StyledModalHeader>
          <StyledModalBody container spacing={2}>
            <Grid item xs={12}>
              <SGSubtitle variant={'s1'}>Are you sure you want to view all these IDFs?</SGSubtitle>
            </Grid>
            <Grid item xs={12}>
              <SGBody variant={'b4'}>
                Selecting 10 or more IDFs may create performance delays and take longer to load.
              </SGBody>
            </Grid>
            <Grid item xs={12}>
              <StyledButton onClick={handleConfirm}>OK</StyledButton>
            </Grid>
          </StyledModalBody>
        </StyledPaper>
      </Fade>
    </StyledModal>
  );
}

export default MultipleSelectionWarningModal;
